import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
  setEffects(state, payload) {
    state.effects = payload;
  },
  setSar(state, payload) {
    state.sar = payload;
  },
  setTypes(state, payload) {
    state.types = payload;
  },
  setTxRules(state, payload) {
    state.tx.rules = payload;
  },
  setTxTypes(state, payload) {
    state.tx.types = payload;
  },
};
